/**
 * Read-only diary / workouts (GET); optional PT delegation via forUser.
 */

import { apiFetch } from './client';

export interface DiaryListRow {
  date?: string;
  rawMarkdown?: unknown;
  notes?: unknown;
  entityType?: string;
  updatedAt?: string;
}

export interface WorkoutListRow {
  date?: string;
  startTime?: string;
  endTime?: string;
  workoutLogId?: string;
  type?: string;
  source?: string;
  programId?: string;
  dayNumber?: number;
  exercises?: unknown;
  notes?: string;
  entityType?: string;
  updatedAt?: string;
}

function qsparams(opts?: { forUser?: string; from?: string; to?: string }): string {
  const p = new URLSearchParams();
  if (opts?.forUser) p.set('forUser', opts.forUser);
  if (opts?.from) p.set('from', opts.from);
  if (opts?.to) p.set('to', opts.to);
  const qs = p.toString();
  return qs ? `?${qs}` : '';
}

export async function getDiary(opts?: {
  forUser?: string;
  from?: string;
  to?: string;
}): Promise<{ userId: string; diary: DiaryListRow[] }> {
  return apiFetch(`/diary${qsparams(opts)}`);
}

export async function getWorkouts(opts?: {
  forUser?: string;
  from?: string;
  to?: string;
}): Promise<{ userId: string; workouts: WorkoutListRow[] }> {
  return apiFetch(`/workouts${qsparams(opts)}`);
}
